import React from 'react';

const Loading = () => (
  <div className="container loading-container">
    <div className="row">
      <div className="col-sm-12">
        <h1>BASIC PAGE</h1>
      </div>
    </div>
    <div className="row">
      <div className="col-sm-12">
        <br />
        <br />
        <p>LOADING CONTENT LOADING CONTENT</p>
        <p>LOADING CONTENT LOADING CONTENT</p>
        <p>LOADING CONTENT LOADING CONTENT</p>
      </div>
    </div>
  </div>
);

export default Loading;
